import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
//import HomePage from './components/HomePage';
import IntegrationGuide from './components/IntegrationGuide';
import ImplementationList from './components/ImplementationList';
//import OffTheShelf from './components/OffTheShelf';
import Resources from './components/Resources';
import QuickStartGuide from './components/QuickStartGuide';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/*<Route path="/" element={<HomePage />} />*/}
            {/*<Route path="/integration-guide" element={<IntegrationGuide />} />*/}
            <Route path="/" element={<IntegrationGuide />} />
            <Route path="/implementation-list" element={<ImplementationList />} />
            {/*<Route path="/off-the-shelf" element={<OffTheShelf />} />*/}
            <Route path="/resources" element={<Resources />} />
            <Route path="/quick-start-guide" element={<QuickStartGuide />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;